import React, { useRef } from "react";
import { auth } from "./../firebase";
import { authenticatedFetch } from "../services/apiClient";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Popup from "./Form/Popup";

const ResetPassword = () => {
  const navigate = useNavigate();
  const passwordRef = useRef();
  const prevPasswordRef = useRef();

  const resetPassword = async () => {
    const oldPassword = prevPasswordRef.current.value;
    const newPassword = passwordRef.current.value;

    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    
    try {
      const res = await authenticatedFetch(`${BACKEND_URL}/api/auth/reset-password`, {
        method: "POST",
        body: JSON.stringify({
          uid: user.uid,
          oldPassword,
          newPassword,
        }),
      });

      const json = await res.json();

      if (json.success) {
        alert("Password updated successfully!");
        navigate("/manageuser");
      } else {
        alert(json.message);
      }
    } catch (error) {
      console.error("Reset password error:", error);
      alert("Failed to reset password");
    }
  };

  return (
    <div className="manage--user">
      {/* {isPopupVisible ? <Popup reAuth={true} setIsPopupVisible={setIsPopupVisible} getCredentialFromPopup={getCredentialFromPopup}/> : null} */}
      <div className="container">
        <h1>Reset password</h1>
        <input ref={passwordRef} type="password" placeholder="New password" />
        <input
          ref={prevPasswordRef}
          type="password"
          placeholder="Current password"
        />
        <button onClick={resetPassword}>Change password</button>
      </div>
    </div>
  );
};

export default ResetPassword;
